/* eslint-disable react/prop-types */
import React from "react";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  ListItem,
  TextField,
  Typography
} from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useStyles } from "./termSheet.style";
import { HtmlTooltip } from "./TooltipContent";
import AddIcon from "./assets/AddIcon.svg";

const TermSheetRequirement = (props) => {
  const classes = useStyles();
  const {
    termSheetData,
    isUserConfig,
    termSheetConfig,
    isDownloadingTermSheet
  } = props;

  const handleAddRequiremnt = () => {
    const reqToBeChecked =
      termSheetData?.requirements || termSheetConfig.requirements;
    const emptyReqExist = reqToBeChecked?.some((requirement) => {
      return requirement === "";
    });
    if (!emptyReqExist) {
      const tempObj = termSheetData ? { ...termSheetData } : {};
      termSheetConfig?.updateTermSheetFormData("requirements", [
        ...tempObj.requirements,
        ""
      ]);
    }
  };

  const handleRequirmentChange = (index, value) => {
    const tempObj = termSheetData ? { ...termSheetData } : {};
    const newReq = tempObj.requirements;
    newReq[index] = value;
    termSheetConfig?.updateTermSheetFormData("requirements", [...newReq]);
  };

  const handleDeleteRequirment = (rowIndex) => {
    const tempObj = termSheetData ? { ...termSheetData } : {};
    const newReq = tempObj.requirements;

    newReq.splice(rowIndex, 1);
    termSheetConfig?.updateTermSheetFormData("requirements", [...newReq]);
  };

  return (
    <Grid container className={classes.requirementContiner}>
      <Grid item xs={11}>
        <Typography className={classes.requirementTitle}>
          Requirements
        </Typography>

        {termSheetData &&
          termSheetData?.requirements?.map((requirement, index) => {
            return isUserConfig &&
              !termSheetConfig?.isViewMode &&
              !isDownloadingTermSheet ? (
              <HtmlTooltip title={requirement}>
                <TextField
                  className={classes.requirementInputBox}
                  value={requirement}
                  onChange={(e) => {
                    return handleRequirmentChange(index, e.target.value);
                  }}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <span className={classes.verticalDivider} />
                        <IconButton
                          title='Delete'
                          style={{ padding: 0 }}
                          onClick={() => {
                            handleDeleteRequirment(index);
                          }}
                        >
                          <DeleteOutlinedIcon fontSize='small' />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </HtmlTooltip>
            ) : (
              requirement !== "" && (
                <ListItem
                  sx={{
                    display: "list-item",
                    fontSize: "13px",
                    marginLeft: isDownloadingTermSheet ? "16px" : ""
                  }}
                >
                  <span
                    style={{
                      marginLeft: isDownloadingTermSheet ? "-32px" : ""
                    }}
                  >
                    {requirement}
                  </span>
                </ListItem>
              )
            );
          })}
      </Grid>
      <Grid item xs={12}>
        {isUserConfig &&
          !termSheetConfig?.isViewMode &&
          !isDownloadingTermSheet && (
            <Button
              variant='outlined'
              color='primary'
              size='large'
              className={classes.requirementBtn}
              onClick={handleAddRequiremnt}
            >
              <img src={AddIcon} alt='add_icon' /> &ensp; Add Requirements
            </Button>
          )}
      </Grid>
    </Grid>
  );
};

export default React.memo(TermSheetRequirement);
